'use client';

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import type { SheetContentProps } from './SheetContent';
import { SheetContent } from './SheetContent';

export type SheetProps = Omit<SheetContentProps, 'state'> & {
  /** Toggle the visibility of the sheet. */
  isShowing: boolean;
  /** Callback which fires after the sheet has fully unmounted. */
  onExited?: () => void;
};

/**
 * A Sheet is a panel that slides in from the side of the viewport,
 * and floats above the rest of the content.
 *
 * @link [Docs](https://vapor.frame.io/vapor/components/sheet)
 * @link [Storybook](https://main--5de9642270f71d0020378e20.chromatic.com/?path=/story/navigation-sheet-stories--notifications-panel)
 *
 * @example
 * <Sheet
 *  isShowing={isShowing}
 *  onRequestClose={() => setIsShowing(false)}
 *  title="Notifications"
 * >
 *  <Text>Content</Text>
 * </Sheet>
 */
export function Sheet({
  isShowing = false,
  onExited,
  children,
  ...other
}: SheetProps) {
  return (
    <AnimatePresence initial={false} onExitComplete={onExited}>
      {isShowing && (
        <SheetContent key="sheet" {...other}>
          {children}
        </SheetContent>
      )}
    </AnimatePresence>
  );
}
